import React from 'react';
import { FiX, FiRotateCcw } from 'react-icons/fi';
import styles from './Emitir.module.css';
import useEsc from '../../../hooks/useEsc';

/* Campos que existem no layout da NFS-e mas que nenhum cliente daqui usa:
   compras governamentais, destinatário do IBS/CBS e intermediário. Ficavam
   ocupando a etapa inteira pra sempre serem deixados no padrão.

   Aqui eles continuam acessíveis por um ícone, sem roubar espaço de quem
   emite todo dia. O preço disso é campo fora de vista -- por isso o ícone
   avisa quando algo saiu do padrão (ver OPCOES_PADRAO abaixo). */

export const OPCOES_PADRAO = {
  compraGovernamental: false,
  destinatarioAdquirente: '',
  intermediario: '',
};

/* usado pelo cabeçalho pra marcar o ícone e pela revisão pra mostrar o que
   foi mexido -- nada aqui pode ficar escondido sem aviso */
export function opcoesAlteradas(dados) {
  const mudou = [];
  if (dados.compraGovernamental) mudou.push('compra governamental');
  if (dados.destinatarioAdquirente) {
    mudou.push(`destinatário: ${dados.destinatarioAdquirente === 'sim' ? 'é o adquirente' : 'não é o adquirente'}`);
  }
  if (dados.intermediario) mudou.push(`intermediário: ${dados.intermediario}`);
  return mudou;
}

function ModalOpcoesEspeciais({ dados, set, onFechar }) {
  useEsc(onFechar);
  const alteradas = opcoesAlteradas(dados);

  function restaurarPadrao() {
    Object.entries(OPCOES_PADRAO).forEach(([campo, valor]) => set(campo, valor));
  }

  return (
    <div className={styles.modalFundo}>
      <div className={styles.modalCaixa} style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
        <div className={styles.modalTopo}>
          <div>
            <h3 className={styles.modalTitulo}>Opções especiais</h3>
            <p className={styles.modalSub}>
              Situações raras do layout da NFS-e. Se não for o caso, pode fechar sem mexer.
            </p>
          </div>
          <button type="button" className={styles.btnIcone} onClick={onFechar}><FiX size={16} /></button>
        </div>

        <div className={styles.modalCorpo}>
          <div className={styles.campo}>
            <span className={styles.rotulo}>A operação é uma compra governamental?</span>
            <div className={styles.radios}>
              <label className={styles.radio}>
                <input type="radio" checked={!dados.compraGovernamental}
                  onChange={() => set('compraGovernamental', false)} /> Não
              </label>
              <label className={styles.radio}>
                <input type="radio" checked={!!dados.compraGovernamental}
                  onChange={() => set('compraGovernamental', true)} /> Sim
              </label>
            </div>
          </div>

          <div className={styles.campo} style={{ marginTop: 16 }}>
            <span className={styles.rotulo}>Para o IBS/CBS, o destinatário é o próprio adquirente?</span>
            <div className={styles.radios}>
              {[['', 'Não informado'], ['sim', 'Sim'], ['nao', 'Não']].map(([v, l]) => (
                <label key={v || 'vazio'} className={styles.radio}>
                  <input type="radio" checked={(dados.destinatarioAdquirente || '') === v}
                    onChange={() => set('destinatarioAdquirente', v)} /> {l}
                </label>
              ))}
            </div>
          </div>

          <div className={styles.campo} style={{ marginTop: 16 }}>
            <span className={styles.rotulo}>Intermediário do serviço</span>
            <div className={styles.radios}>
              {[['', 'Não informado'], ['brasil', 'Brasil'], ['exterior', 'Exterior']].map(([v, l]) => (
                <label key={v || 'vazio'} className={styles.radio}>
                  <input type="radio" checked={(dados.intermediario || '') === v}
                    onChange={() => set('intermediario', v)} /> {l}
                </label>
              ))}
            </div>
          </div>

          {alteradas.length > 0 && (
            <div className={styles.aviso} style={{ marginTop: 16 }}>
              <div>
                Fora do padrão: <strong>{alteradas.join(' · ')}</strong>.
                <div className={styles.dica}>Isso vai aparecer também na tela de revisão.</div>
              </div>
            </div>
          )}
        </div>

        <div className={styles.modalRodape}>
          <button type="button" className={styles.btnSecundario}
            onClick={restaurarPadrao} disabled={alteradas.length === 0}>
            <FiRotateCcw size={13} /> Voltar ao padrão
          </button>
          <button type="button" className={styles.btnAvancar} onClick={onFechar}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

export default ModalOpcoesEspeciais;
